import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { ErrorBoundary } from '@/components';
import { ENV } from '@/config';
import { buildScaleCss } from '@/config/scale';
import { initTelemetry } from '@/services/telemetry';
import { syncTelemetryUser } from '@/services/auth';
import { registerStaleChunkReload } from '@/utils/staleChunkReload';
import '@/assets/styles/global.css';
import 'antd/dist/reset.css';

// The scale variables must exist before the first paint of any stylesheet rule that reads them.
const scaleStyle = document.createElement('style');
scaleStyle.textContent = buildScaleCss();
document.head.append(scaleStyle);

registerStaleChunkReload();
initTelemetry();
syncTelemetryUser();

// Validate environment on startup (development only)
if (import.meta.env.DEV) {
  // eslint-disable-next-line no-console
  console.log('[ENV] API Base URL:', ENV.apiBaseUrl);
  // eslint-disable-next-line no-console
  console.log('[ENV] API Version:', ENV.apiVersion);
}

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Failed to find the root element');
}

createRoot(rootElement).render(
  <StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </StrictMode>,
);
